import { jsx as o, Fragment as n } from "../../_virtual/jsx-runtime.mjs";
import i, { useEffect as u } from "react";
import c from "./libs/GoogleAutoComplete.mjs";
import { GOOGLE_API_KEY as l } from "./const.mjs";
const g = i.memo((e) => (u(() => {
  var t;
  e.inputChild && new c({
    inputElement: e.inputChild,
    apiKey: e.googleApiKey ?? l,
    options: {
      componentRestrictions: e.country ? { country: e.country } : void 0,
      fields: ["address_components", "geometry"],
      types: ["address"]
    },
    onChooseAddress: e.onChooseAddress,
    language: e.language,
    isUseShortState: (t = e.useShortCountryList) == null ? void 0 : t.includes(e.country[0])
  }).init().catch(console.error);
}, [
  e.country,
  e.googleApiKey,
  e.inputChild,
  e.language,
  e.onChooseAddress,
  e.useShortCountryList
]), /* @__PURE__ */ o(n, {})));
export {
  g as default
};
//# sourceMappingURL=AddressAutoComplete.mjs.map
